'use client';

import { useQuickSearchModal } from '@frameio/quick-search/contexts/QuickSearchContext';
import { useIsQuickSearchV2Enabled } from '@frameio/search/hooks/useIsQuickSearchV2Enabled';
import { useQuickSearchModal as useQuickSearchModalV2 } from '@frameio/search/shared/contexts';
import { IconButton2 as IconButton, theme, Tooltip } from '@frameio/vapor';
import { IconPrimaryNavSearchFill } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/HeaderSearchButton';

TEXT.DEFINE({
  /** Search button label */
  searchLabel: 'Search',
});

/**
 * Renders the search button cta with all the feature flags and context selectors to toggle the modal
 */
export function HeaderSearchButton() {
  const { isEnabled: isQuickSearch2Enabled } = useIsQuickSearchV2Enabled();
  const { toggleModal } = useQuickSearchModal();
  const { openModal: toggleModalV2 } = useQuickSearchModalV2();

  return (
    <Tooltip placement="bottom" title={TEXT.searchLabel}>
      <IconButton
        icon={
          <IconPrimaryNavSearchFill
            color={theme.colors.icon.primary}
            size={16}
          />
        }
        label={TEXT.searchLabel}
        onPressStart={isQuickSearch2Enabled ? toggleModalV2 : toggleModal}
        size="small"
        variant="tertiary-dimmed"
      />
    </Tooltip>
  );
}
